import { render, staticRenderFns } from "./ResizeArrowIcon.vue?vue&type=template&id=59f56146"
import script from "./ResizeArrowIcon.vue?vue&type=script&lang=js"
export * from "./ResizeArrowIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports